import React from "react"
import { Link } from '@reach/router'
import '../App.scss'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSignOutAlt, faSignInAlt, faCaretSquareRight, faList } from "@fortawesome/free-solid-svg-icons"

export const Header = () => {
  return (
    <header className="noprint">
      <nav
        className="navbar is-info "
        role="navigation"
        aria-label="main navigation"
      >
        <div className="container is-fluid">
          <div id="mainNavbar" className={`navbar-brand `}>
            <div className="navbar-start">
              <Link to={"/"} className="navbar-item">
                <FontAwesomeIcon icon={faSignInAlt} className="mr-2" />Entrée
              </Link>
              <Link to={"/sortie"} className="navbar-item">
                <FontAwesomeIcon icon={faSignOutAlt} className="mr-2" />Sortie
              </Link>
              <Link to={"/inventaire"} className="navbar-item">
                <FontAwesomeIcon icon={faList} className="mr-2" />Inventaire
              </Link>
              <a href={"https://backend.producadre.fr/index.php"} target="_blank" rel="noreferrer" className="navbar-item">
                <FontAwesomeIcon icon={faCaretSquareRight} className="mr-2" />Backend
              </a>
            </div>
          </div>
        </div>
      </nav>
    </header>
  )
}
export default Header
